var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageWaiting = function SvgMessageWaiting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M24 4C12.972 4 4 12.972 4 24s8.972 20 20 20 20-8.972 20-20S35.028 4 24 4m0 36c-8.822 0-16-7.178-16-16S15.178 8 24 8s16 7.178 16 16-7.178 16-16 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M26 14h-4v10.828l6.586 6.586 2.828-2.828L26 23.172z"
  })));
};
export { SvgMessageWaiting as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDRDMTIuOTcyIDQgNCAxMi45NzIgNCAyNEM0IDM1LjAyOCAxMi45NzIgNDQgMjQgNDRDMzUuMDI4IDQ0IDQ0IDM1LjAyOCA0NCAyNEM0NCAxMi45NzIgMzUuMDI4IDQgMjQgNFpNMjQgNDBDMTUuMTc4IDQwIDggMzIuODIyIDggMjRDOCAxNS4xNzggMTUuMTc4IDggMjQgOEMzMi44MjIgOCA0MCAxNS4xNzggNDAgMjRDNDAgMzIuODIyIDMyLjgyMiA0MCAyNCA0MFoiIGZpbGw9IiM5MDlBOUYiLz4KPHBhdGggZD0iTTI2IDE0SDIyVjI0LjgyOEwyOC41ODYgMzEuNDE0TDMxLjQxNCAyOC41ODZMMjYgMjMuMTcyVjE0WiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";